import { useContext, useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Box, Drawer, Hidden } from "@mui/material";
import { styled } from "@mui/material/styles";
import SidebarMenu from "./SidebarMenu";
import { SidebarContext } from "../../../contexts/SidebarContext";
import Logo from "../../../shared/components/logo";
import useLazyQuery from "../../../shared/components/hooks/useLazyQuery";
import useMutation from "../../../shared/components/hooks/useMutation";
import { clearLocalStorageData } from "../../../shared/utils/localStorage";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useNavigate } from "react-router-dom"; // For navigation

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        color: ${theme.sidebar.textColor};
        background: ${theme.sidebar.background};
        height: 100%;
        padding-bottom: 11%;
        padding-left: 16px;
        box-shadow: ${theme.sidebar.boxShadow};
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            position: fixed;
            z-index: 10;
           
        }
`
);

const TopSection = styled(Box)(
  ({ theme }) => `
        display: flex;
        height: 13%;
        align-items: center;
        margin-bottom:  ${theme.spacing(2)};
        border-bottom: 1px solid ${theme.sidebar.dividerBg};
        
`
);
const LogoutBlock = styled(Box)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1.5)};
    padding: ${theme.spacing(0.85)};
    margin: ${theme.spacing(2)};
    cursor: pointer;
    color: ${theme.palette.error.main};
    background: rgba(255, 0, 0, 0.1);    
    border: 0.75px solid ${theme.palette.error.main};
    border-radius: 8px;
    transition: background 0.3s, border-color 0.3s;
    box-shadow: 0 2px 4px rgba(255, 0, 0, 0.15);
    position: relative;
    bottom:5%;

    &:hover {
      background: rgba(255, 0, 0, 0.33);      
      border-color: ${theme.palette.error.dark};
      color: #0a0a0a;
      box-shadow: 0 4px 8px rgba(255, 0, 0, 0.2);
    }
  `
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();

  const { data: permissions, fetchData } = useLazyQuery(
    "admin/administrators/permissions"
  );
  const { modifyData } = useMutation();

  useEffect(() => {
    fetchData();
  }, []);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate(); // For navigation
   const handleLogout = () => {
    // Clear localStorage and redirect to login page
    localStorage.clear(); // Clears all keys in localStorage
    // Alternatively, to remove specific keys:
    // localStorage.removeItem("authToken");

    navigate("/login"); // Redirect to login page
    setAnchorEl(null); // Close the menu
  };

  return (
    <>
      <Hidden lgDown>
        <SidebarWrapper>
          <TopSection>
            <Logo />
          </TopSection>

          <Scrollbars autoHide>
            <SidebarMenu userData={(permissions as any)?.data} />
          </Scrollbars>
          <LogoutBlock onClick={handleLogout}>
            <LogoutOutlinedIcon />
            <span>Logout</span>
          </LogoutBlock>
        </SidebarWrapper>
      </Hidden>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggle}
          onClose={closeSidebar}
          variant="temporary"
          elevation={9}
        >
          <SidebarWrapper>
            <Scrollbars autoHide>
              <TopSection>
                <Logo />
              </TopSection>
              <SidebarMenu userData={(permissions as any)?.data} />
            </Scrollbars>
            <LogoutBlock onClick={handleLogout}>
              <LogoutOutlinedIcon />
              <span>Logout</span>
            </LogoutBlock>
          </SidebarWrapper>
        </Drawer>
      </Hidden>
    </>
  );
}

export default Sidebar;
